<style lang="scss">
  .quiz-question {
    margin-bottom: 1rem;

    .quiz-choices.inline {
      display: flex;
      justify-content: normal;

      .custom-checkbox, .custom-radio {
        margin-right: 1rem;
      }
    }
  }
</style>

<template>
  <div class="quiz-question">
    <h4 v-text="title">
      <i v-if="success" class="fas fa-check-double"></i>
    </h4>
    <blockquote
      v-if="description"
      v-html="description"
    >
    </blockquote>
    <div
      v-bind:class="{inline}"
      class="quiz-choices quiz-choices-radio"
      v-if="isRadios">
      <base-radio
        v-for="choice in choices"
        :name="choice.value"
        :key="choice.value"
        :disabled="disabled"
        v-model="model"
      >
        {{ choice.label }}
      </base-radio>
    </div>
    <div
      class="quiz-choices quiz-choices-checkbox"
      v-bind:class="{inline}"
      v-else-if="isCheckboxes">
      <base-checkbox
        v-for="choice in choices"
        :key="choice.value"
        :disabled="disabled"
        v-model="model[choice.value]"
      >
        {{ choice.label }}
      </base-checkbox>
    </div>
    <div v-else-if="isSelect">
      <base-input>
        <el-select v-model="model"
                   :disabled="disabled"
                   :placeholder="placeholder || title"
                   filterable>
          <el-option v-for="choice in choices"
                     :key="choice.label"
                     :label="choice.label"
                     :value="choice.value">
          </el-option>
        </el-select>
      </base-input>
    </div>
    <div v-else-if="isMultiSelect">
      <base-input>
        <el-select v-model="model"
                   multiple
                   :disabled="disabled"
                   :placeholder="placeholder || title"
                   filterable>
          <el-option v-for="choice in choices"
                     :key="choice.label"
                     :label="choice.label"
                     :value="choice.value">
          </el-option>
        </el-select>
      </base-input>
    </div>
    <div v-else>
      <h3>Ошибка в спецификации вопроса</h3>
    </div>
    <div
      v-if="showResult && result"
      v-html="result">
    </div>
  </div>
</template>

<script>
  import { _ } from 'vue-underscore';

  export default {
    name: "QuizQuestion",
    computed: {
      success() {
        // console.log('model answ', this.model);
        // console.log('refer answ', this.answers);
        const model = this.transformValue(this.model);
        // console.log('trans model', model);
        return _.isEqual(_.sortBy(model), _.sortBy(this.answers));
      },

      isManyChoices() {
        return this.choices.length >= this.countDivider
      },

      isRadios() {
        return !this.allowMultiple && !this.isManyChoices
      },

      isCheckboxes() {
        return this.allowMultiple && !this.isManyChoices
      },

      isSelect() {
        return !this.allowMultiple && this.isManyChoices
      },

      isMultiSelect() {
        return this.allowMultiple && this.isManyChoices
      },

      result() {
        if (_.isEmpty(this.model)) {
          return undefined
        } else {
          return this.success ?
            this.$i18n.t('<span class="text-success">Right!</span>') :
            this.$i18n.t('<span class="text-danger">Wrong!</span>')
        }
      }
    },
    data() {
      return {
        model: undefined
      }
    },
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: "Сделайте свой выбор"
      },
      allowMultiple: {
        type: Boolean,
        default: true
      },
      choices: {
        type: Array,
        required: true
      },
      answers: {
        type: Array,
        required: true
      },
      countDivider: {
        type: Number,
        default: 5
      },
      inline: {
        type: Boolean,
        default: true
      },
      showResult: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    created() {
      this.model = this.isCheckboxes ? {} : (this.isRadios ? "" : []);
    },
    methods: {
      transformValue(val) {
        if (!_.isEmpty(val) && this.isCheckboxes) {
          return _.keys(
            _.pick(val, function(value, key, object) {
              return value === true;
            })
          )
        }
        if (!_.isEmpty(val) && typeof val == "string") {
          return Array(val)
        }
        return val
      },
      emitter(val) {
        if (val) {
          this.$emit("input", this.transformValue(val))
        }
      }
    },
    watch: {
      'model': function (val) {
        this.emitter(val)
      }
    }
  }
</script>
